export const CURRENT_FOLDER_SET='CURRENT_FOLDER_SET'
